import React, { useContext, useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import { AppContext } from '@/AppContext';
import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { Button, Card, Grid, Typography } from '@mui/material';
import Divider from '@mui/material/Divider';
import { ECCommonErrorBlock } from '@/components/Forms/ECCommonErrorBlock';
import { ECTextField } from '@/components/Forms/ECTextField';
import { ECDateField } from '@/components/Forms/ECDateField';
import { ECSelectField } from '@/components/Forms/ECSelectField';
import moment from 'moment-timezone';
import EventInfo from '../EventInfo';
import { errorsToForm } from '@/components/Forms/form_utils';
import ModalDialog from '@/components/ModalDialog/ModalDialog';

const PREFIX = 'InfoContacts';

const classes = {
  root: `${PREFIX}-root`,
  tableContainer__title: `${PREFIX}-tableContainer__title`,
  cardContainer: `${PREFIX}-cardContainer`,
};

const StyledModalDialog = styled(ModalDialog)(({ theme }) => ({
  [`& .${classes.root}`]: {
    padding: theme.spacing(3),
  },

  [`& .${classes.tableContainer__title}`]: {
    paddingLeft: 25,
    fontSize: 20,
  },

  [`& .${classes.cardContainer}`]: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    paddingTop: 0,
  },
}));

const InfoContacts = props => {
  const appContext = useContext(AppContext);
  const { mid: meetupId } = useParams();
  const { goBack } = props;
  const form = useForm();
  const [initial, setInitial] = useState(undefined);

  useEffect(() => {
    appContext.eventInfoApi.getContacts(meetupId).then(({ data }) => {
      setInitial(data);
    });
  }, [meetupId]);

  const handleSave = () => {
    const data = form.getValues();
    data.meetupId = meetupId;
    appContext.eventInfoApi
      .updateContacts(meetupId, data)
      .then(({ data }) => {
        goBack(data);
      })
      .catch(errorsToForm(form));
  };

  if (!initial) {
    return null;
  }

  return (
    <StyledModalDialog title={'Контакты'} okButtonText={'Сохранить'} handleOk={handleSave} handleClose={goBack}>
      <ECCommonErrorBlock form={form} />
      <Grid container spacing={3}>
        <Grid size={12}>
          <ECTextField label='Контакты' name='contacts' form={form} initial={initial} multiline rows={4} />
        </Grid>
      </Grid>
    </StyledModalDialog>
  );
};

export default InfoContacts;
